const cyrillicToTranslit = require('../../node_modules/cyrillic-to-translit-js/CyrillicToTranslit');

export default cyrillicToTranslit();
